import {render} from './render.js';

import {
  selectTool,
  selectGrade,
  selectPerson,
  selectSchool,
  inputJobTitle,
  selectDepartment
} from './stateUpdateHandlers.js';

import {
  EVENT_INIT_FORM,
  EVENT_UPDATED_TOOL,
  EVENT_UPDATED_GRADE,
  EVENT_UPDATED_PERSON,
  EVENT_UPDATED_SCHOOL,
  EVENT_UPDATED_JOB_TITLE,
  EVENT_UPDATED_DEPARTMENT
} from './consts';

export function update(state, event, value) {
  let newState;

  switch (event) {
    case EVENT_INIT_FORM:
      newState = {...state};
      break;

    case EVENT_UPDATED_SCHOOL:
      newState = selectSchool(state, value);
      break;

    case EVENT_UPDATED_PERSON:
      newState = selectPerson(state, value);
      break;

    case EVENT_UPDATED_TOOL:
      newState = selectTool(state, value);
      break;

    case EVENT_UPDATED_DEPARTMENT:
      newState = selectDepartment(state, value);
      break;

    case EVENT_UPDATED_GRADE:
      newState = selectGrade(state, value);
      break;

    case EVENT_UPDATED_JOB_TITLE:
      newState = inputJobTitle(state, value);
      break;

    default:
      break;
  }

  window.requestAnimationFrame(() => render(newState, event));

  return newState;
}
